import { computed, inject, markRaw, onBeforeUnmount, ref, Ref, UnwrapRef } from 'vue';

export function elementRef<T extends Element>(): Ref<UnwrapRef<T | undefined>> {
  let current: Element | undefined;
  return computed<any>({
    get() {
      return current;
    },
    set(value) {
      if (value instanceof Element) {
        current = value;
      } else if (value && '$el' in value) {
        current = value.$el;
      }
    },
  });
}

export function componentRef<T = any>(): Ref<UnwrapRef<T | undefined>> {
  return ref<T | undefined>(undefined);
}

export interface Form {
  // eslint-disable-next-line no-unused-vars
  get(path?: string): any;

  // eslint-disable-next-line no-unused-vars
  set(path: string, value: any): void;

  getDataObject(): any;

  // eslint-disable-next-line no-unused-vars
  hasError(path: string): boolean | undefined;

  // eslint-disable-next-line no-unused-vars
  getErrors(path: string): Array<string>;

  // eslint-disable-next-line no-unused-vars
  setWarning(path: string, message?: string): void;

  // eslint-disable-next-line no-unused-vars
  getWarning(path: string): string | undefined;

  // eslint-disable-next-line no-unused-vars
  submit(event?: Event): void;

  close(): void;
}

export function useForm(): Form | undefined {
  return inject<Form>('form', undefined); // passing undefined as default avoids injection warning
}

export function hasForm(): boolean {
  return !!inject('hasForm');
}

/**
 * Simple utility function that calls multiple hooks {@link onBeforeUnmount}.
 * Makes cleanup logic in components slightly less verbose.
 */
export function cleanup(...hooks: Array<() => any>): void {
  onBeforeUnmount(() => hooks.forEach(h => h()));
}

interface Loader<R extends NonNullable<unknown>, A extends Array<any>> {
  // eslint-disable-next-line no-unused-vars
  (...args: A): Promise<Array<R>>;
}

export function withRawResults<R extends NonNullable<unknown>, A extends Array<any>>(loader: Loader<R, A>): Loader<R, A> {
  return async (...args) => {
    const results = await loader(...args);
    results.forEach(markRaw);
    return results;
  };
}